import { render, staticRenderFns } from "./UploadImgIcon.vue?vue&type=template&id=8bbb2e74&scoped=true&"
import script from "./UploadImgIcon.vue?vue&type=script&lang=js&"
export * from "./UploadImgIcon.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgIcon.vue?vue&type=style&index=0&id=8bbb2e74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbb2e74",
  null
  
)

export default component.exports